import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { GraduationCapIcon, MapPinIcon } from 'lucide-react';
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function EducationSection() {
  const ref = useRef<HTMLElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section id="education" ref={ref} className="py-20" style={{
    backgroundColor: '#f8fafc'
  }} data-id="element-70">
      <div className="max-w-5xl mx-auto px-6" data-id="element-71">
        <motion.div variants={itemVariants} initial="hidden" animate={isInView ? 'visible' : 'hidden'} className="mb-12" data-id="element-72">
          <h2 className="font-display" style={{
          fontFamily: 'Playfair Display, serif',
          fontSize: 'clamp(28px, 4vw, 38px)',
          fontWeight: 700,
          letterSpacing: '0.05em',
          color: '#0d1b4b',
          paddingBottom: '10px',
          borderBottom: '2px solid var(--gold)',
          display: 'inline-block'
        }} data-id="element-73">
            EDUCATION
          </h2>
        </motion.div>

        <motion.div variants={itemVariants} initial="hidden" animate={isInView ? 'visible' : 'hidden'} data-id="element-74">
          <div className="flex flex-col sm:flex-row items-start gap-5 p-6 rounded-md bg-white" style={{
          border: '1px solid rgba(13,27,75,0.1)',
          borderLeft: '3px solid var(--gold)',
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
        }} data-id="element-75">
            {/* Icon */}
            <div className="flex items-center justify-center w-12 h-12 rounded-md flex-shrink-0" style={{
            background: 'linear-gradient(135deg, #0d1f4e, #1a3a8f)'
          }} data-id="element-76">
              <GraduationCapIcon size={22} style={{
              color: 'white'
            }} data-id="element-77" />
            </div>

            {/* Content */}
            <div className="flex-1" data-id="element-78">
              <p style={{
              fontFamily: 'Inter, sans-serif',
              fontSize: '11px',
              color: 'var(--gold)',
              letterSpacing: '0.15em',
              textTransform: 'uppercase',
              marginBottom: '6px',
              fontWeight: 600
            }} data-id="element-79">
                Bachelor of Science
              </p>
              <h3 style={{
              fontFamily: 'Playfair Display, serif',
              fontSize: '20px',
              fontWeight: 700,
              marginBottom: '8px',
              color: '#0d1b4b'
            }} data-id="element-80">
                Management
              </h3>
              <div className="flex flex-wrap gap-x-5 gap-y-1.5" data-id="element-81">
                <span className="flex items-center gap-1.5" style={{
                fontFamily: 'Inter, sans-serif',
                fontSize: '13px',
                color: '#4b5563'
              }} data-id="element-82">
                  <GraduationCapIcon size={13} style={{
                  color: 'var(--gold)'
                }} data-id="element-83" />
                  Dallas Baptist University
                </span>
                <span className="flex items-center gap-1.5" style={{
                fontFamily: 'Inter, sans-serif',
                fontSize: '13px',
                color: '#4b5563'
              }} data-id="element-84">
                  <MapPinIcon size={13} style={{
                  color: 'var(--gold)'
                }} data-id="element-85" />
                  Dallas, TX
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}